import React from "react";
import BreadCrumb from "./BreadCrumb";
import ChallengeControls from "./ChallengeControls";
import "../../../../../styles/ambassadorChallenge/overview.scss";
import TopParticipants from "./TopParticipants";
import Summary from "./Summary";
import { useAmbassadorChallengeContext } from "../../../../../contexts/AmbassadorChallengeContext";
import NoActiveChallenge from "./NoActiveChallenge";
import ManageChallenge from "./ManageChallenge/ManageChallenge";
import WallOfFame from "./WallOfFame/WallOfFame";

function Overview() {
  const { view, leaderboardResponse } = useAmbassadorChallengeContext();


  return (
    <main className="main">
      {view === "overview" && (
        <>
          <BreadCrumb />
          <Summary />
          {leaderboardResponse && leaderboardResponse.message ==='No active challenge' ? <NoActiveChallenge /> : <ChallengeControls />}
          <TopParticipants />
        </>
      )}

       {view === "manage" && (
        <>
          <ManageChallenge />
        </>
      )}

      {view === "Wall Of Fame" && (
        <>
          <BreadCrumb />
          <WallOfFame />
        </>
      )}
    </main>
  );
}

export default Overview;
